module.exports = __webpack_public_path__ + "img/thumb_23.8a14cdaa.jpg";